// Whether a failed profile request means "this session is gone" or only "the server could not be
// asked". The two used to be treated alike, so a backend outage logged every reader out.

interface MaybeAxiosError {
	response?: { status?: number };
}

/** The server answered and refused the token: a 4xx other than a timeout or a rate limit. */
export const isSessionRejected = (error: unknown): boolean => {
	const status = (error as MaybeAxiosError | null)?.response?.status;
	if (typeof status !== "number") return false;
	return status >= 400 && status < 500 && status !== 408 && status !== 429;
};

const RETRY_DELAYS_MS = [2_000, 5_000, 10_000, 30_000];

/** Backoff for retrying the profile while the server is unreachable; settles at 30s. */
export const profileRetryDelay = (attempt: number): number =>
	RETRY_DELAYS_MS[Math.min(Math.max(attempt, 0), RETRY_DELAYS_MS.length - 1)];
